export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDateTime: { input: any; output: any; }
  AWSEmail: { input: any; output: any; }
};

export type ActionStep = {
  __typename?: 'ActionStep';
  description: Scalars['String']['output'];
  link: Scalars['String']['output'];
};

export type ActionStepInput = {
  description: Scalars['String']['input'];
  link: Scalars['String']['input'];
};

export type AddDestinationInput = {
  acknowledgers: DestinationInput;
  destinations: DestinationInput;
  documentType: Scalars['String']['input'];
  fromOrganizationCode: Scalars['String']['input'];
  fromOrganizationType: Scalars['String']['input'];
};

export type Agreement = {
  __typename?: 'Agreement';
  communityCode: Scalars['String']['output'];
  content: Scalars['String']['output'];
  creationDate: Scalars['AWSDateTime']['output'];
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type AllNotificationReadStatus = {
  __typename?: 'AllNotificationReadStatus';
  readStatus: Scalars['Boolean']['output'];
  userId: Scalars['String']['output'];
};

export type AllNotificationsReadStatusInput = {
  readStatus: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};

export type ArchiveNotificationInput = {
  notificationUUID: Scalars['String']['input'];
};

export type ArchiveReadNotificationsInput = {
  unread?: InputMaybe<Scalars['String']['input']>;
};

export type Attachment = {
  __typename?: 'Attachment';
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: Status;
  url: Scalars['String']['output'];
};

export type AttachmentInput = {
  fileName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  link: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  status: Status;
  url: Scalars['String']['input'];
};

export type AttachmentScope = {
  application: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
  parentType: Scalars['String']['input'];
};

export type Attachments = {
  __typename?: 'Attachments';
  application: Scalars['String']['output'];
  attachments: Array<Attachment>;
  owner: Scalars['String']['output'];
  parentId: Scalars['String']['output'];
  parentType: Scalars['String']['output'];
};

export type AttachmentsInput = {
  application: Scalars['String']['input'];
  attachments: Array<AttachmentInput>;
  owner: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
  parentType: Scalars['String']['input'];
};

export type Classification = {
  __typename?: 'Classification';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ClassificationInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type Configuration = {
  __typename?: 'Configuration';
  community: Scalars['ID']['output'];
  constants?: Maybe<Array<Constant>>;
  entityEnabledFields?: Maybe<Array<EntityEnabledField>>;
  enums: Array<Enumeration>;
  featureToggles?: Maybe<Array<FeatureToggle>>;
};

export type Constant = {
  __typename?: 'Constant';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CustomProperty = {
  __typename?: 'CustomProperty';
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type CustomPropertyInput = {
  name: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteEnumerationValueInput = {
  code: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type Destination = {
  __typename?: 'Destination';
  organizationCode: Scalars['String']['output'];
  organizationType: Scalars['String']['output'];
};

export type DestinationInput = {
  toOrganizationCode: Scalars['String']['input'];
  toOrganizationType: Scalars['String']['input'];
};

export enum DistributionType {
  Email = 'email',
  InApplication = 'inApplication'
}

export type Document = {
  __typename?: 'Document';
  attachments: Array<Attachment>;
  crn: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rejectionMessages?: Maybe<Array<Scalars['String']['output']>>;
  scope: Scope;
  status: Scalars['String']['output'];
};

export enum DocumentStatus {
  Acknowledged = 'ACKNOWLEDGED',
  Draft = 'DRAFT',
  None = 'NONE',
  Published = 'PUBLISHED',
  Rejected = 'REJECTED'
}

export type DocumentUpdate = {
  __typename?: 'DocumentUpdate';
  crn: Scalars['String']['output'];
  document: Document;
  organization: Scalars['String']['output'];
};

export type Documents = {
  __typename?: 'Documents';
  documents: Array<Document>;
  organization: Scalars['String']['output'];
};

export type EntityEnabledField = {
  __typename?: 'EntityEnabledField';
  custom?: Maybe<Scalars['Boolean']['output']>;
  fields?: Maybe<Array<EntityEnabledField>>;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type EnumValue = {
  __typename?: 'EnumValue';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentValue?: Maybe<Scalars['String']['output']>;
};

export type EnumValueInput = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parentValue?: InputMaybe<Scalars['String']['input']>;
};

export type Enumeration = {
  __typename?: 'Enumeration';
  parentType?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  values: Array<Maybe<EnumValue>>;
};

export type EnumerationInput = {
  type: Scalars['String']['input'];
  values: Array<EnumValueInput>;
};

export type EnumerationValueInput = {
  parentType?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  value: EnumValueInput;
};

export type FeatureToggle = {
  __typename?: 'FeatureToggle';
  feature: Scalars['String']['output'];
  toggled: Scalars['Boolean']['output'];
};

export type GetAttachmentsInput = {
  application: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
  parentType: Scalars['String']['input'];
};

export type GetDocumentsInput = {
  crn: Scalars['String']['input'];
};

export type GetNotificationsInput = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type GetNotificationsResult = {
  __typename?: 'GetNotificationsResult';
  notifications?: Maybe<Array<NotificationMessageDto>>;
  token?: Maybe<Scalars['String']['output']>;
};

export type Location = {
  __typename?: 'Location';
  aliases?: Maybe<Array<Scalars['String']['output']>>;
  customProperties?: Maybe<Array<CustomProperty>>;
  id: Scalars['String']['output'];
  maxBeam?: Maybe<Scalars['Int']['output']>;
  maxLength?: Maybe<Scalars['Int']['output']>;
  nameLong: Scalars['String']['output'];
  nameShort: Scalars['String']['output'];
  port: Scalars['String']['output'];
  source: LocationSource;
  type: Scalars['String']['output'];
};

export type LocationPageToken = {
  __typename?: 'LocationPageToken';
  id: Scalars['String']['output'];
  orderingIndexKey?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export type LocationPageTokenInput = {
  id: Scalars['String']['input'];
  orderingIndexKey?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export enum LocationSource {
  Custom = 'CUSTOM',
  Maistro = 'MAISTRO',
  Unknown = 'UNKNOWN'
}

export type MarkAllNotificationsReadStatusInput = {
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarkNotificationReadStateInput = {
  notificationUUID: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addDestination?: Maybe<Routing>;
  archiveNotification?: Maybe<NotificationMessageDto>;
  archiveReadNotifications?: Maybe<Scalars['Boolean']['output']>;
  createAdmin?: Maybe<User>;
  createOrganization?: Maybe<Organization>;
  createUser?: Maybe<User>;
  deleteEnumValue?: Maybe<Configuration>;
  deleteLocation?: Maybe<Location>;
  deleteUser: User;
  deleteVessel?: Maybe<Vessel>;
  disableFeature?: Maybe<Scalars['Boolean']['output']>;
  enableFeature?: Maybe<Scalars['Boolean']['output']>;
  markAllNotificationsReadStatus?: Maybe<Scalars['Boolean']['output']>;
  markNotificationRead?: Maybe<NotificationMessageDto>;
  markNotificationUnread?: Maybe<NotificationMessageDto>;
  notifyCommunityAttachmentsUpdate?: Maybe<Attachments>;
  notifyDocumentUpdate?: Maybe<DocumentUpdate>;
  notifyOrganizationAttachmentsUpdate?: Maybe<Attachments>;
  popToast?: Maybe<Scalars['Boolean']['output']>;
  publish?: Maybe<DocumentUpdate>;
  publishReadNotificationsArchived?: Maybe<ReadNotificationsArchived>;
  pushToast?: Maybe<Scalars['Boolean']['output']>;
  putAllNotificationsReadStatus?: Maybe<AllNotificationReadStatus>;
  putEnum?: Maybe<Configuration>;
  putEnumValue?: Maybe<Configuration>;
  putLocation?: Maybe<Location>;
  putNotification?: Maybe<NotificationMessageDto>;
  putNotificationConfig?: Maybe<UserRuleConfiguration>;
  putNotificationTotals?: Maybe<NotificationTotals>;
  putVessel?: Maybe<Vessel>;
  refreshClientSecret: RefreshClientSecretResult;
  registerAgreementAccord?: Maybe<Array<Agreement>>;
  removeNotification?: Maybe<RemoveNotificationMessageId>;
  sendAllUsersNotification?: Maybe<Scalars['Boolean']['output']>;
  setAssignableRoles?: Maybe<Organization>;
  setRoles: User;
  setSelectedPort?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationAddDestinationArgs = {
  input: AddDestinationInput;
};


export type MutationArchiveNotificationArgs = {
  input?: InputMaybe<ArchiveNotificationInput>;
};


export type MutationArchiveReadNotificationsArgs = {
  input?: InputMaybe<ArchiveReadNotificationsInput>;
};


export type MutationCreateAdminArgs = {
  email: Scalars['AWSEmail']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  organizationCode: Scalars['String']['input'];
  organizationType: Scalars['String']['input'];
};


export type MutationCreateOrganizationArgs = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};


export type MutationCreateUserArgs = {
  email: Scalars['AWSEmail']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteEnumValueArgs = {
  input: DeleteEnumerationValueInput;
};


export type MutationDeleteLocationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationDeleteVesselArgs = {
  input: Scalars['ID']['input'];
};


export type MutationDisableFeatureArgs = {
  feature: Scalars['String']['input'];
};


export type MutationEnableFeatureArgs = {
  feature: Scalars['String']['input'];
};


export type MutationMarkAllNotificationsReadStatusArgs = {
  input?: InputMaybe<MarkAllNotificationsReadStatusInput>;
};


export type MutationMarkNotificationReadArgs = {
  input?: InputMaybe<MarkNotificationReadStateInput>;
};


export type MutationMarkNotificationUnreadArgs = {
  input?: InputMaybe<MarkNotificationReadStateInput>;
};


export type MutationNotifyCommunityAttachmentsUpdateArgs = {
  community: Scalars['String']['input'];
  input: GetAttachmentsInput;
};


export type MutationNotifyDocumentUpdateArgs = {
  organization: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
};


export type MutationNotifyOrganizationAttachmentsUpdateArgs = {
  input: GetAttachmentsInput;
  organization: Scalars['String']['input'];
};


export type MutationPublishArgs = {
  input: PublishInput;
};


export type MutationPublishReadNotificationsArchivedArgs = {
  input?: InputMaybe<ReadNotificationsArchivedInput>;
};


export type MutationPushToastArgs = {
  toast: ToastInput;
};


export type MutationPutAllNotificationsReadStatusArgs = {
  input?: InputMaybe<AllNotificationsReadStatusInput>;
};


export type MutationPutEnumArgs = {
  input: EnumerationInput;
};


export type MutationPutEnumValueArgs = {
  input: EnumerationValueInput;
};


export type MutationPutLocationArgs = {
  input: PutLocationInput;
};


export type MutationPutNotificationArgs = {
  input?: InputMaybe<NotificationMessageInput>;
};


export type MutationPutNotificationConfigArgs = {
  input?: InputMaybe<PutNotificationConfigInput>;
};


export type MutationPutNotificationTotalsArgs = {
  input?: InputMaybe<NotificationTotalsInput>;
};


export type MutationPutVesselArgs = {
  input: VesselInput;
};


export type MutationRegisterAgreementAccordArgs = {
  input: RegisterAgreementAccordInput;
};


export type MutationRemoveNotificationArgs = {
  input?: InputMaybe<RemoveNotificationMessageInput>;
};


export type MutationSendAllUsersNotificationArgs = {
  input?: InputMaybe<SendAllUsersNotificationInput>;
};


export type MutationSetAssignableRolesArgs = {
  assignableRoles: Array<Scalars['String']['input']>;
  organizationCode: Scalars['String']['input'];
  organizationType: Scalars['String']['input'];
};


export type MutationSetRolesArgs = {
  roles: Array<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationSetSelectedPortArgs = {
  port?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationAttachment = {
  __typename?: 'NotificationAttachment';
  fileName: Scalars['String']['output'];
  link: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
};

export type NotificationMessageDto = {
  __typename?: 'NotificationMessageDTO';
  actionSteps?: Maybe<Array<ActionStep>>;
  attachments?: Maybe<Array<NotificationAttachment>>;
  isRead: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  receivedTime: Scalars['AWSDateTime']['output'];
  subject: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type NotificationMessageInput = {
  actionSteps?: InputMaybe<Array<ActionStepInput>>;
  attachments?: InputMaybe<Array<AttachmentInput>>;
  isRead: Scalars['Boolean']['input'];
  message: Scalars['String']['input'];
  receivedTime: Scalars['AWSDateTime']['input'];
  subject: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type NotificationToken = {
  uuid: Scalars['String']['input'];
};

export type NotificationTotals = {
  __typename?: 'NotificationTotals';
  open: Scalars['Int']['output'];
  unread: Scalars['Int']['output'];
  userId: Scalars['String']['output'];
};

export type NotificationTotalsInput = {
  open: Scalars['Int']['input'];
  unread: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};

export type Organization = {
  __typename?: 'Organization';
  assignableRoles: Array<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  communityCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  owner: Scalars['String']['output'];
  timeZone?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type OrganizationIdInput = {
  code: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type OwnOrganization = {
  __typename?: 'OwnOrganization';
  assignableRoles: Array<Scalars['String']['output']>;
  communityName: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PublishInput = {
  crn: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
};

export type PutLocationInput = {
  aliases: Array<Scalars['String']['input']>;
  customProperties?: InputMaybe<Array<CustomPropertyInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  maxBeam?: InputMaybe<Scalars['Int']['input']>;
  maxLength?: InputMaybe<Scalars['Int']['input']>;
  nameLong: Scalars['String']['input'];
  nameShort: Scalars['String']['input'];
  port: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type PutNotificationConfigInput = {
  active: Scalars['Boolean']['input'];
  distribution: DistributionType;
  id: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  getAccordedAgreements?: Maybe<Array<Agreement>>;
  getAllNotifications?: Maybe<GetNotificationsResult>;
  getAttachments?: Maybe<Attachments>;
  getCommunityAttachments?: Maybe<Attachments>;
  getCommunityCode: Scalars['String']['output'];
  getConfiguration?: Maybe<Configuration>;
  getDocuments?: Maybe<Documents>;
  getLocation?: Maybe<Location>;
  getNonAccordedAgreements?: Maybe<Array<Agreement>>;
  getNotificationTotals?: Maybe<NotificationTotals>;
  getNotifications?: Maybe<Array<NotificationMessageDto>>;
  getOpenNotifications?: Maybe<GetNotificationsResult>;
  getOrganization?: Maybe<OwnOrganization>;
  getOrganizationAttachments?: Maybe<Attachments>;
  getOrganizationDetails?: Maybe<Organization>;
  getOwner: Scalars['String']['output'];
  getUserConfiguration?: Maybe<UserConfiguration>;
  getVesselByMMSI?: Maybe<Vessel>;
  listCommunityRoles?: Maybe<Array<Scalars['String']['output']>>;
  listMyRoles: Array<Scalars['String']['output']>;
  listOrganizationTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listOrganizations?: Maybe<Array<Maybe<Organization>>>;
  listPorts?: Maybe<Array<Maybe<Organization>>>;
  listRoles: Array<Scalars['String']['output']>;
  listUsers?: Maybe<Array<Maybe<User>>>;
  loggedIn?: Maybe<User>;
  readVessel?: Maybe<Vessel>;
  searchLocationByPort?: Maybe<SearchLocationResult>;
  searchNotifications?: Maybe<GetNotificationsResult>;
  searchVessel?: Maybe<SearchVesselResult>;
  selectedPort?: Maybe<Scalars['String']['output']>;
  toasts: Array<Maybe<Toast>>;
};


export type QueryGetAllNotificationsArgs = {
  input: GetNotificationsInput;
};


export type QueryGetAttachmentsArgs = {
  input: GetAttachmentsInput;
};


export type QueryGetCommunityAttachmentsArgs = {
  input: GetAttachmentsInput;
};


export type QueryGetDocumentsArgs = {
  input: GetDocumentsInput;
};


export type QueryGetLocationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetNotificationsArgs = {
  input: GetNotificationsInput;
};


export type QueryGetOpenNotificationsArgs = {
  input: GetNotificationsInput;
};


export type QueryGetOrganizationAttachmentsArgs = {
  input: GetAttachmentsInput;
};


export type QueryGetOrganizationDetailsArgs = {
  input?: InputMaybe<OrganizationIdInput>;
};


export type QueryGetVesselByMmsiArgs = {
  input?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListOrganizationsArgs = {
  typeFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReadVesselArgs = {
  input: Scalars['ID']['input'];
};


export type QuerySearchLocationByPortArgs = {
  lastPageToken?: InputMaybe<LocationPageTokenInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  port: Scalars['String']['input'];
  searchString: Scalars['String']['input'];
};


export type QuerySearchNotificationsArgs = {
  input: SearchNotificationsInput;
};


export type QuerySearchVesselArgs = {
  lastPageToken?: InputMaybe<VesselPageTokenInput>;
  pageSize: Scalars['Int']['input'];
  query: Scalars['String']['input'];
};

export type ReadNotificationsArchived = {
  __typename?: 'ReadNotificationsArchived';
  userId: Scalars['String']['output'];
};

export type ReadNotificationsArchivedInput = {
  userId: Scalars['String']['input'];
};

export type RefreshClientSecretResult = {
  __typename?: 'RefreshClientSecretResult';
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
};

export type RegisterAgreementAccordInput = {
  agreementId: Scalars['String']['input'];
};

export type RemoveNotificationMessageId = {
  __typename?: 'RemoveNotificationMessageId';
  userId: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type RemoveNotificationMessageInput = {
  userId: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type Routing = {
  __typename?: 'Routing';
  classification: Scalars['String']['output'];
  community: Scalars['ID']['output'];
  destinations?: Maybe<Array<Destination>>;
};

export type Scope = {
  __typename?: 'Scope';
  application: Scalars['String']['output'];
  parentId: Scalars['String']['output'];
  parentType: Scalars['String']['output'];
};

export type ScopeInput = {
  application: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
  parentType: Scalars['String']['input'];
};

export type SearchLocationResult = {
  __typename?: 'SearchLocationResult';
  lastPageToken?: Maybe<LocationPageToken>;
  locations?: Maybe<Array<Location>>;
};

export type SearchNotificationsInput = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type SearchVesselResult = {
  __typename?: 'SearchVesselResult';
  lastPageToken?: Maybe<VesselPageToken>;
  vessels: Array<Vessel>;
};

export type SendAllUsersNotificationInput = {
  message: Scalars['String']['input'];
  recipients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scope: AttachmentScope;
  subject: Scalars['String']['input'];
};

export enum Status {
  Clean = 'CLEAN',
  Deleted = 'DELETED',
  Infected = 'INFECTED',
  PendingVirusCheck = 'PENDING_VIRUS_CHECK'
}

export type Subscription = {
  __typename?: 'Subscription';
  attachmentsUpdatedSubscription?: Maybe<Attachments>;
  communityAttachmentsUpdatedSubscription?: Maybe<Attachments>;
  createOrganizationSubscription?: Maybe<Organization>;
  createUserSubscription?: Maybe<User>;
  deleteUserSubscription?: Maybe<User>;
  documentUpdatedSubscription?: Maybe<DocumentUpdate>;
  notificationTotalsSubscription?: Maybe<NotificationTotals>;
  organizationAttachmentsUpdatedSubscription?: Maybe<Attachments>;
  publishReadNotificationsArchivedSubscription?: Maybe<ReadNotificationsArchived>;
  putAllNotificationsReadStatusSubscription?: Maybe<AllNotificationReadStatus>;
  putNotificationSubscription?: Maybe<NotificationMessageDto>;
  removeNotificationSubscription?: Maybe<RemoveNotificationMessageId>;
  userUpdatedSubscription?: Maybe<User>;
};


export type SubscriptionAttachmentsUpdatedSubscriptionArgs = {
  application: Scalars['String']['input'];
  owner: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
  parentType: Scalars['String']['input'];
};


export type SubscriptionCommunityAttachmentsUpdatedSubscriptionArgs = {
  application: Scalars['String']['input'];
  owner: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
  parentType: Scalars['String']['input'];
};


export type SubscriptionCreateOrganizationSubscriptionArgs = {
  communityCode: Scalars['String']['input'];
};


export type SubscriptionCreateUserSubscriptionArgs = {
  owner: Scalars['String']['input'];
};


export type SubscriptionDeleteUserSubscriptionArgs = {
  owner: Scalars['String']['input'];
};


export type SubscriptionDocumentUpdatedSubscriptionArgs = {
  crn: Scalars['String']['input'];
  organization: Scalars['String']['input'];
};


export type SubscriptionNotificationTotalsSubscriptionArgs = {
  userId: Scalars['String']['input'];
};


export type SubscriptionOrganizationAttachmentsUpdatedSubscriptionArgs = {
  application: Scalars['String']['input'];
  owner: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
  parentType: Scalars['String']['input'];
};


export type SubscriptionPublishReadNotificationsArchivedSubscriptionArgs = {
  userId: Scalars['String']['input'];
};


export type SubscriptionPutAllNotificationsReadStatusSubscriptionArgs = {
  userId: Scalars['String']['input'];
};


export type SubscriptionPutNotificationSubscriptionArgs = {
  userId: Scalars['String']['input'];
};


export type SubscriptionRemoveNotificationSubscriptionArgs = {
  userId: Scalars['String']['input'];
};


export type SubscriptionUserUpdatedSubscriptionArgs = {
  owner: Scalars['String']['input'];
};

export type Toast = {
  __typename?: 'Toast';
  message: Scalars['String']['output'];
};

export type ToastInput = {
  message: Scalars['String']['input'];
};

export type User = {
  __typename?: 'User';
  email: Scalars['AWSEmail']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owner: Scalars['String']['output'];
  roles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UserConfiguration = {
  __typename?: 'UserConfiguration';
  rules?: Maybe<Array<UserRuleConfiguration>>;
};

export type UserRuleConfiguration = {
  __typename?: 'UserRuleConfiguration';
  email: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  inApplication: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  subcategory: Scalars['String']['output'];
};

export type Vessel = {
  __typename?: 'Vessel';
  callSign?: Maybe<Scalars['String']['output']>;
  classifications?: Maybe<Array<Classification>>;
  communityID?: Maybe<Scalars['String']['output']>;
  eni?: Maybe<Scalars['String']['output']>;
  grossTonnage?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  imo?: Maybe<Scalars['String']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  mmsi?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  passengerCapacity?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  subType?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uscg?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type VesselInput = {
  callSign?: InputMaybe<Scalars['String']['input']>;
  classifications?: InputMaybe<Array<ClassificationInput>>;
  eni?: InputMaybe<Scalars['String']['input']>;
  grossTonnage?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imo?: InputMaybe<Scalars['String']['input']>;
  length?: InputMaybe<Scalars['Int']['input']>;
  mmsi?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  passengerCapacity?: InputMaybe<Scalars['Int']['input']>;
  subType?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  uscg?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type VesselPageToken = {
  __typename?: 'VesselPageToken';
  orderingIndexKey?: Maybe<Scalars['String']['output']>;
  vesselId: Scalars['String']['output'];
  weight?: Maybe<Scalars['Int']['output']>;
};

export type VesselPageTokenInput = {
  orderingIndexKey?: InputMaybe<Scalars['String']['input']>;
  vesselId: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementFragmentFragment = { __typename?: 'Agreement', id: string, title: string, content: string, creationDate: any };

export type GetAccordedAgreementsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccordedAgreementsQuery = { __typename?: 'Query', getAccordedAgreements?: Array<{ __typename?: 'Agreement', id: string, title: string, content: string, creationDate: any }> | null };

export type GetNonAccordedAgreementsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNonAccordedAgreementsQuery = { __typename?: 'Query', getNonAccordedAgreements?: Array<{ __typename?: 'Agreement', id: string, title: string, content: string, creationDate: any }> | null };

export type RegisterAgreementAccordMutationVariables = Exact<{
  input: RegisterAgreementAccordInput;
}>;


export type RegisterAgreementAccordMutation = { __typename?: 'Mutation', registerAgreementAccord?: Array<{ __typename?: 'Agreement', id: string, title: string, content: string, creationDate: any }> | null };

export type CommunityAttachmentsUpdatedSubscriptionSubscriptionVariables = Exact<{
  owner: Scalars['String']['input'];
  application: Scalars['String']['input'];
  parentType: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
}>;


export type CommunityAttachmentsUpdatedSubscriptionSubscription = { __typename?: 'Subscription', communityAttachmentsUpdatedSubscription?: { __typename?: 'Attachments', owner: string, application: string, parentType: string, parentId: string, attachments: Array<{ __typename?: 'Attachment', id: string, name: string, mimeType: string, url: string, status: Status }> } | null };

export type AttachmentFragment = { __typename?: 'Attachment', id: string, name: string, mimeType: string, url: string, status: Status };

export type AttachmentsFragment = { __typename?: 'Attachments', owner: string, application: string, parentType: string, parentId: string, attachments: Array<{ __typename?: 'Attachment', id: string, name: string, mimeType: string, url: string, status: Status }> };

export type GetCommunityAttachmentsQueryVariables = Exact<{
  input: GetAttachmentsInput;
}>;


export type GetCommunityAttachmentsQuery = { __typename?: 'Query', getCommunityAttachments?: { __typename?: 'Attachments', owner: string, application: string, parentType: string, parentId: string, attachments: Array<{ __typename?: 'Attachment', id: string, name: string, mimeType: string, url: string, status: Status }> } | null };

export type GetCommunityConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCommunityConfigurationQuery = { __typename?: 'Query', getConfiguration?: { __typename?: 'Configuration', community: string, constants?: Array<{ __typename?: 'Constant', key: string, value: string }> | null, enums: Array<{ __typename?: 'Enumeration', type: string, parentType?: string | null, values: Array<{ __typename?: 'EnumValue', code: string, name: string, parentValue?: string | null } | null> }>, featureToggles?: Array<{ __typename?: 'FeatureToggle', feature: string, toggled: boolean }> | null, entityEnabledFields?: Array<{ __typename?: 'EntityEnabledField', name: string, label: string, type: string, custom?: boolean | null, fields?: Array<{ __typename?: 'EntityEnabledField', name: string, label: string, type: string, custom?: boolean | null, fields?: Array<{ __typename?: 'EntityEnabledField', name: string, label: string, type: string, custom?: boolean | null, fields?: Array<{ __typename?: 'EntityEnabledField', name: string, label: string, type: string, custom?: boolean | null }> | null }> | null }> | null }> | null } | null };

export type GetOrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationQuery = { __typename?: 'Query', getOwner: string };

export type ListOrganizationTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListOrganizationTypesQuery = { __typename?: 'Query', listOrganizationTypes?: Array<string | null> | null };

export type LoggedInQueryVariables = Exact<{ [key: string]: never; }>;


export type LoggedInQuery = { __typename?: 'Query', loggedIn?: { __typename?: 'User', id: string, name: string, email: any, roles?: Array<string | null> | null } | null };

export type SearchLocationsByPortQueryVariables = Exact<{
  port: Scalars['String']['input'];
  searchString: Scalars['String']['input'];
  pageSize: Scalars['Int']['input'];
  lastPageToken?: InputMaybe<LocationPageTokenInput>;
}>;


export type SearchLocationsByPortQuery = { __typename?: 'Query', searchLocationByPort?: { __typename?: 'SearchLocationResult', lastPageToken?: { __typename?: 'LocationPageToken', id: string, orderingIndexKey?: string | null, weight?: number | null } | null, locations?: Array<{ __typename?: 'Location', id: string, port: string, nameShort: string, nameLong: string, type: string, aliases?: Array<string> | null, source: LocationSource, customProperties?: Array<{ __typename?: 'CustomProperty', name: string, value?: string | null }> | null }> | null } | null };

export type ArchiveNotificationMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ArchiveNotificationMutation = { __typename?: 'Mutation', archiveNotification?: { __typename?: 'NotificationMessageDTO', userId: string, uuid: string, receivedTime: any, subject: string, message: string, isRead: boolean, actionSteps?: Array<{ __typename?: 'ActionStep', description: string, link: string }> | null, attachments?: Array<{ __typename?: 'NotificationAttachment', fileName: string, link: string, mimeType: string }> | null } | null };

export type ArchiveReadNotificationsMutationVariables = Exact<{ [key: string]: never; }>;


export type ArchiveReadNotificationsMutation = { __typename?: 'Mutation', archiveReadNotifications?: boolean | null };

export type NotificationMessageDtoFragment = { __typename?: 'NotificationMessageDTO', userId: string, uuid: string, receivedTime: any, subject: string, message: string, isRead: boolean, actionSteps?: Array<{ __typename?: 'ActionStep', description: string, link: string }> | null, attachments?: Array<{ __typename?: 'NotificationAttachment', fileName: string, link: string, mimeType: string }> | null };

export type UserRuleConfigurationFragment = { __typename?: 'UserRuleConfiguration', id: string, name: string, subcategory: string, email: boolean, inApplication: boolean };

export type GetNotificationTotalsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationTotalsQuery = { __typename?: 'Query', getNotificationTotals?: { __typename?: 'NotificationTotals', unread: number, userId: string, open: number } | null };

export type GetOpenNotificationsQueryVariables = Exact<{
  pageSize: Scalars['Int']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOpenNotificationsQuery = { __typename?: 'Query', getOpenNotifications?: { __typename?: 'GetNotificationsResult', token?: string | null, notifications?: Array<{ __typename?: 'NotificationMessageDTO', userId: string, uuid: string, receivedTime: any, subject: string, message: string, isRead: boolean, actionSteps?: Array<{ __typename?: 'ActionStep', description: string, link: string }> | null, attachments?: Array<{ __typename?: 'NotificationAttachment', fileName: string, link: string, mimeType: string }> | null }> | null } | null };

export type GetUserConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserConfigurationQuery = { __typename?: 'Query', getUserConfiguration?: { __typename?: 'UserConfiguration', rules?: Array<{ __typename?: 'UserRuleConfiguration', id: string, name: string, subcategory: string, email: boolean, inApplication: boolean }> | null } | null };

export type MarkAllNotificationsReadStatusMutationVariables = Exact<{
  isRead: Scalars['Boolean']['input'];
}>;


export type MarkAllNotificationsReadStatusMutation = { __typename?: 'Mutation', markAllNotificationsReadStatus?: boolean | null };

export type MarkNotificationReadMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type MarkNotificationReadMutation = { __typename?: 'Mutation', markNotificationRead?: { __typename?: 'NotificationMessageDTO', userId: string, uuid: string, receivedTime: any, subject: string, message: string, isRead: boolean, actionSteps?: Array<{ __typename?: 'ActionStep', description: string, link: string }> | null, attachments?: Array<{ __typename?: 'NotificationAttachment', fileName: string, link: string, mimeType: string }> | null } | null };

export type MarkNotificationUnreadMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type MarkNotificationUnreadMutation = { __typename?: 'Mutation', markNotificationUnread?: { __typename?: 'NotificationMessageDTO', userId: string, uuid: string, receivedTime: any, subject: string, message: string, isRead: boolean, actionSteps?: Array<{ __typename?: 'ActionStep', description: string, link: string }> | null, attachments?: Array<{ __typename?: 'NotificationAttachment', fileName: string, link: string, mimeType: string }> | null } | null };

export type PutNotificationConfigMutationVariables = Exact<{
  input?: InputMaybe<PutNotificationConfigInput>;
}>;


export type PutNotificationConfigMutation = { __typename?: 'Mutation', putNotificationConfig?: { __typename?: 'UserRuleConfiguration', id: string, name: string, subcategory: string, email: boolean, inApplication: boolean } | null };

export type SearchNotificationsQueryVariables = Exact<{
  pageSize: Scalars['Int']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
  query: Scalars['String']['input'];
}>;


export type SearchNotificationsQuery = { __typename?: 'Query', searchNotifications?: { __typename?: 'GetNotificationsResult', token?: string | null, notifications?: Array<{ __typename?: 'NotificationMessageDTO', userId: string, uuid: string, receivedTime: any, subject: string, message: string, isRead: boolean, actionSteps?: Array<{ __typename?: 'ActionStep', description: string, link: string }> | null, attachments?: Array<{ __typename?: 'NotificationAttachment', fileName: string, link: string, mimeType: string }> | null }> | null } | null };

export type SendAllUsersNotificationMutationVariables = Exact<{
  subject: Scalars['String']['input'];
  message: Scalars['String']['input'];
  scope: AttachmentScope;
  recipients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type SendAllUsersNotificationMutation = { __typename?: 'Mutation', sendAllUsersNotification?: boolean | null };

export type NotificationTotalsSubscriptionSubscriptionVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type NotificationTotalsSubscriptionSubscription = { __typename?: 'Subscription', notificationTotalsSubscription?: { __typename?: 'NotificationTotals', open: number, unread: number } | null };

export type PublishReadNotificationsArchivedSubscriptionSubscriptionVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type PublishReadNotificationsArchivedSubscriptionSubscription = { __typename?: 'Subscription', publishReadNotificationsArchivedSubscription?: { __typename?: 'ReadNotificationsArchived', userId: string } | null };

export type PutAllNotificationsReadStatusSubscriptionSubscriptionVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type PutAllNotificationsReadStatusSubscriptionSubscription = { __typename?: 'Subscription', putAllNotificationsReadStatusSubscription?: { __typename?: 'AllNotificationReadStatus', readStatus: boolean } | null };

export type PutNotificationSubscriptionSubscriptionVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type PutNotificationSubscriptionSubscription = { __typename?: 'Subscription', putNotificationSubscription?: { __typename?: 'NotificationMessageDTO', userId: string, uuid: string, receivedTime: any, subject: string, message: string, isRead: boolean, actionSteps?: Array<{ __typename?: 'ActionStep', description: string, link: string }> | null, attachments?: Array<{ __typename?: 'NotificationAttachment', fileName: string, link: string, mimeType: string }> | null } | null };

export type RemoveNotificationSubscriptionSubscriptionVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type RemoveNotificationSubscriptionSubscription = { __typename?: 'Subscription', removeNotificationSubscription?: { __typename?: 'RemoveNotificationMessageId', uuid: string } | null };

export type ListPortsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListPortsQuery = { __typename?: 'Query', selectedPort?: string | null, listPorts?: Array<{ __typename?: 'Organization', name: string, code: string, owner: string, timeZone?: string | null } | null> | null };

export type SetSelectedPortMutationVariables = Exact<{
  port?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetSelectedPortMutation = { __typename?: 'Mutation', setSelectedPort?: boolean | null };

export type GetToastsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetToastsQuery = { __typename?: 'Query', toasts: Array<{ __typename?: 'Toast', message: string } | null> };

export type PopToastMutationVariables = Exact<{ [key: string]: never; }>;


export type PopToastMutation = { __typename?: 'Mutation', popToast?: boolean | null };

export type PushToastMutationVariables = Exact<{
  toast: ToastInput;
}>;


export type PushToastMutation = { __typename?: 'Mutation', pushToast?: boolean | null };

export type SearchVesselQueryVariables = Exact<{
  query: Scalars['String']['input'];
  pageSize: Scalars['Int']['input'];
  lastPageToken?: InputMaybe<VesselPageTokenInput>;
}>;


export type SearchVesselQuery = { __typename?: 'Query', searchVessel?: { __typename?: 'SearchVesselResult', vessels: Array<{ __typename?: 'Vessel', id: string, name?: string | null, imo?: string | null, eni?: string | null, mmsi?: string | null, callSign?: string | null, uscg?: string | null }>, lastPageToken?: { __typename?: 'VesselPageToken', vesselId: string, weight?: number | null, orderingIndexKey?: string | null } | null } | null };
